export enum EnvNames {
  DEV = "dev",
  DEV3 = "dev3",
  SIT1 = "sit1",
  SIT2 = "sit2",
  PERF = "perf",
  PROD = "prod",
}
